import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  sixtyVariantRoot: {
    height: '290px',
    display: 'flex',
    justifyContent: 'center',
    backdropFilter: 'blur(80px)',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.productFeatureLightBlue,
  },
  sixtyVariantRootGrey: {
    backgroundColor: theme.palette.background.productFeatureLightGrey,
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      '& > div > img': {
        margin: '0 auto',
        width: '80%',
      },
    },
  },
  icon: {
    display: 'flex',
    flexWrap: 'wrap',
    position: 'relative',
    '& svg': {
      width: '100%',
    },
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  title: {
    textAlign: 'center',
    width: '80%',
    fontSize: '1.5rem',
    lineHeight: '1.74rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
      lineHeight: '1.50rem',
    },
  },

  ctaVariantRoot: {
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },

  ctaVariantContainer: {
    display: 'flex',
    padding: '30px 0px 0px 30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  ctaVariantTitle: {
    textAlign: 'auto',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  imageContainer: {
    alignSelf: 'end',
    position: 'relative',
    '& > img': {
      width: '160%',
      transform: 'translate(-125px, 10px)',
    },
    [theme.breakpoints.down('sm')]: {
      justifySelf: 'end',
      marginTop: theme.spacing(3),
      alignSelf: 'center',
      '& > img': {
        width: '90%',
        transform: 'translate(0px, 10px)',
      },
    },
  },

  button: {
    marginTop: theme.spacing(3),
    borderRadius: theme.spacing(0.25),
    fontSize: '1rem',
  },

  twentyVariantRoot: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: 'calc(20% - 11px)',
    height: '290px',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    backdropFilter: 'blur(80px)',
    '& svg': {
      fill: theme.palette.text.primary,
    },
  },

  disclaimerText: {
    color: theme.palette.text.hint,
    position: 'relative',
    bottom: theme.spacing(-4),
  },

  fortyVariantRoot: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: 'calc(40% - 10px)',
    height: '290px',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    backdropFilter: 'blur(80px)',
    '& svg': {
      fill: theme.palette.text.primary,
    },
  },

  fortyVariantRootLeft: {
    textAlign: 'left !important',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: theme.spacing(5),
  },

  fortyVariantTitle: {
    fontSize: '1.25rem',
    textShadow: theme.palette.text.shadow,
  },

  fortyVariantSubTypeImage: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  fortyVariantTitleForImage: {
    fontSize: '1.5rem',
    color: theme.palette.text.secondary,
    position: 'absolute',
    bottom: '50px',
    textAlign: 'center',
  },

  sixtyVariantAfterSalesRoot: {
    width: 'calc(60% - 10px)',
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(4),
      height: 'auto',
      '& > img': {
        width: '100%',
      },
    },
  },

  fortyVariantAfterSalesRoot: {
    width: 'calc(40% - 10px)',
    height: '290px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(5),
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    backdropFilter: 'blur(80px)',
    [theme.breakpoints.down('sm')]: {
      height: '400px',
    },
  },

  fortyVariantTitleAfterSales: {
    fontSize: '1rem',
  },

  fortyVariantIconAfterSales: {
    '& svg': {
      fill: theme.palette.text.primary,
    },
    marginBottom: theme.spacing(3),
  },

  fortyVariantLinkAfterSales: {
    marginTop: theme.spacing(3),
    '& a': {
      fontSize: '1rem',
    },
  },

  fortyVariantButtonAfterSales: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1, 3),
    borderRadius: '2px',
  },

  fortyVariantImageAfterSalesRoot: {
    width: 'calc(40% - 10px)',
    height: '290px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    backdropFilter: 'blur(80px)',
    '& > div': {
      width: '200px',
      [theme.breakpoints.down('sm')]: {
        width: '370px !important',
      },
    },
  },

  variantImageAfterSales: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    '& > h1': {
      marginBottom: theme.spacing(2),
    },

    [theme.breakpoints.down('sm')]: {
      width: '80%',
      alignItems: 'center',
      '& img': {
        alignSelf: 'end',
        margin: '0 auto',
        width: '80%',
      },
    },
  },

  seventyVariantRoot: {
    width: 'calc(70% - 10px)',
    height: '290px',
    backdropFilter: 'blur(80px)',
    padding: '40px',
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    '& svg': {
      fill: theme.palette.text.primary,
    },
    '& > h4': {
      fontSize: '1.5rem',
    },
  },

  iconListContainer: {
    display: 'flex',
    flexDirection: 'column',
    columnWrap: 'wrap',
    height: '100%',
    flexFlow: 'column wrap',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
    },
  },

  iconListItem: {
    display: 'flex',
    width: '30%',
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& svg': {
      minWidth: '20px',
      marginRight: theme.spacing(2),
    },
  },

  iconListItemFleetFinancing: {
    display: 'flex',
    width: '100%',
    marginBottom: theme.spacing(3),
    '& svg': {
      minWidth: '20px',
      marginRight: theme.spacing(2),
    },
  },

  hundredVariantRoot: {
    width: '100%',
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      height: '290px',
    },
    padding: theme.spacing(5),
    backdropFilter: 'blur(80px)',
    '& > h4': {
      fontSize: '1.5rem',
    },
  },

  hundredVariantTextContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    '& > h4': {
      fontSize: '1.5rem',
    },
  },

  thirtyVariantRoot: {
    height: '290px',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backdropFilter: 'blur(80px)',
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    '& > h6': {
      marginTop: theme.spacing(3),
    },
    '& > p': {
      marginTop: theme.spacing(1),
    },
    '& svg': {
      fill: theme.palette.text.primary,
    },
  },

  thirtyVariantRootFleetFinancing: {
    height: '290px',
    padding: theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backdropFilter: 'blur(80px)',
    backgroundColor: theme.palette.background.productFeatureLightGrey,
    '& > h6': {
      marginTop: theme.spacing(3),
    },
    '& > p': {
      marginTop: theme.spacing(1),
    },
    '& svg': {
      fill: theme.palette.text.primary,
    },
  },

  fortyVariantButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1, 3),
    borderRadius: theme.spacing(0.25),
    fontSize: '1rem',
    '& svg': {
      fill: theme.palette.text.secondary,
    },
  },
  footerText: {
    color: theme.palette.text.lightGrey,
    marginTop: theme.spacing(3),
    fontSize: '0.75rem',
  },
}))
